<template>
  <div id="i_checkout">
    <!-- 項目Tab -->
    <ul
      id="inquire_Tab"
      class="nav nav-tabs"
      role="tablist"
    >
      <li class="nav-item">
        <a
          id="i_document_tab"
          class="nav-link"
          href="#/inquire/document"
          role="tab"
          aria-controls="i_document_list"
          aria-selected="false"
        >
          證件申請
        </a>
      </li>
      <li class="nav-item">
        <a
          id="i_checkout_tab"
          class="nav-link active"
          href="#/inquire/checkout"
          role="tab"
          aria-controls="i_checkout_list"
          aria-selected="true"
        >
          費用結算
        </a>
      </li>
      <li class="nav-item">
        <a
          id="i_order_tab"
          class="nav-link"
          href="#/inquire/order"
          role="tab"
          aria-controls="i_order_list"
          aria-selected="false"
        >
          訂單查詢
        </a>
      </li>
    </ul>
    <!-- 費用結算 -->
    <div
      id="i_checkout_list"
      class="tab-pane fade show content-color"
      role="tabpanel"
    >
      <div class="col-12 pt-3 user-div">
        <h5 class="mb-3 word-bold">
          步驟一：確認證件項目明細
        </h5>
        訂單編號：{{ OrderNo }}
        <b-table
          hover
          small
          bordered
          show-empty
          stacked="md"
          :items="items"
          :fields="fields"
        >
          <!-- 流水號 -->
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <!-- 證件名稱 -->
          <template v-slot:cell(PaymentName)="data">
            <span class="nukWord">
              {{ data.item.PaymentName }}
            </span>
          </template>
          <!-- 數量 -->
          <template v-slot:cell(DocCnt)="data">
            <div style="text-align: center;">
              <input
                type="button"
                value="-"
                class="inputbutton float-left"
                @click="ReduceOrderModifycnt(data.item)"
              >
              {{ data.item.DocCnt }}
              <input
                type="button"
                value="+"
                class="inputbutton float-right"
                @click="AddOrderModifycnt(data.item)"
              >
            </div>
          </template>
          <!-- 單價 -->
          <template v-slot:cell(DocAmt)="data">
            <div style="text-align: center;">
              {{ data.item.DocAmt + ' 元' }}
            </div>
          </template>
          <!-- 小計 -->
          <template v-slot:cell(TotalAmt)="data">
            <div style="text-align: center;">
              {{ data.item.TotalAmt + ' 元' }}
            </div>
          </template>
          <!-- 功能 -->
          <template v-slot:cell(Action)="data">
            <button
              type="button"
              class="btn btn-danger"
              title="刪除"
              @click="ShowDeleData(data.item)"
            >
              <font-awesome-icon
                icon="times"
                class="mr-1"
              />
              刪除
            </button>
          </template>
        </b-table>
        <div class="row pt-2">
          <div class="col-xl-4 inquire-price">
            證件項目總金額：
            <span class="span_Amount">
              {{ DocTotalAmt }}
            </span>
            元
          </div>
        </div>
        <hr>
        <h5 class="mb-3 word-bold">
          步驟二：選擇郵資
        </h5>
        <div class="form-group row px-3">
          <label
            for="add_postage"
            class="div-label"
          >
            選擇郵資：
          </label>
          <div class="col-xl-3">
            <select
              id="add_postage"
              class="form-control"
              v-model="PostageAmt"
            >
              <option
                v-for="data in Select"
                :key="data.id"
                :value="data.TotalAmt +','+ data.PostageId"
              >
                {{ data.PostageName }}
              </option>
            </select>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-xl-4 inquire-price">
            郵資總金額：
            <span
              class="span_Amount"
              v-if="PostageAmt !== ''"
            >
              {{ parseInt(PostageAmt.toString().split(',', 1)) }}
            </span>
            元
          </div>
        </div>
        <hr>
        <h5 class="mb-3 word-bold">
          步驟三：結帳確認
        </h5>
        <div class="row margin-1px">
          <div class="col-xl-2 inquire-mon">
            證件項目總金額：
            <span class="span_Amount">
              {{ DocTotalAmt }}
            </span>
            元
          </div>
          <div class="col-xl-10" />
        </div>
        <div class="row margin-1px">
          <div class="col-xl-2 inquire-mon">
            郵資總金額：
            <span
              class="span_Amount"
              v-if="PostageAmt !== ''"
            >
              {{ parseInt(PostageAmt.toString().split(',', 1)) }}
            </span>
            元
          </div>
          <div class="col-xl-10" />
        </div>
        <div class="row pt-2">
          <div class="col-xl-4 inquire-price">
            結帳總金額：
            <span
              class="span_Amount"
              v-if="PostageAmt !== ''"
            >
              {{ TotalAmt = DocTotalAmt + parseInt(PostageAmt.toString().split(',', 1)) }}
            </span>
            元
          </div>
        </div>
        <br>
        <!-- 結帳 -->
        <div class="row pt-3">
          <div class="col-xl-2" />
          <div class="col-xl-8">
            <button
              class="btn btn-primary btn-lg btn-block"
              type="button"
              @click="CheckUserData"
            >
              結帳
            </button>
          </div>
          <div class="col-xl-2" />
        </div>
        <br>
      </div>
    </div>
    <!-- 刪除 Modal -->
    <div
      id="DeleCheckout"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="DeleCheckoutCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="Checkout"
      >
        <div class="modal-content content-color">
          <div class="modal-header content-header">
            <h5
              id="DeleCheckoutLongTitle"
              class="modal-title"
            >
              刪除證件項目
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body content-color">
            確認是否刪除「{{ DeleData.DocName }}」項目?
            <br><hr>
            <button
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="PostDelData"
            >
              刪除
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 確認結帳資訊 Modal -->
    <div
      id="CheckUser"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="CheckUserTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content content-color">
          <div class="modal-header content-header">
            <h5
              class="modal-title"
              id="CheckUserTitle"
            >
              確認結帳資訊
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body content-color">
            <!-- 紅色警告訊息 -->
            <div class="alert alert-danger alert-modal">
              <strong style="color: #dc3545; font-size: 15px;">
                中華郵政自114年8月26日起 暫停收寄發往美國之商品類郵件<br>
              </strong>
              <strong style="color: #dc3545; font-size: 13px;">
                Mail delivery to the United States has been suspended by Chunghwa Post since August 26, 2025. Delivery of academic documents to U.S. addresses is temporarily unavailable.
              </strong>
            </div>
            <!-- 姓名 -->
            <label
              for="add_name"
              class="col-form-label"
            >
              中文姓名:
            </label>
            <input
              class="form-control nukWord"
              type="text"
              v-model="Userdata.UserName"
            >
            <!-- 姓名 -->
            <label
              for="add_ename"
              class="col-form-label"
            >
              英文姓名:
            </label>
            <input
              class="form-control"
              type="text"
              v-model="Userdata.EnglishName"
            >
            <!-- 聯絡信箱 -->
            <label
              for="add_email"
              class="col-form-label"
            >
              <span style="color: red">
                *
              </span>
              聯絡信箱:
            </label>
            <input
              class="form-control"
              type="email"
              v-model="Userdata.Email"
            >
            <!-- 聯絡電話 -->
            <label
              for="add_tel"
              class="col-form-label"
            >
              <span style="color: red">
                *
              </span>
              聯絡電話:
            </label>
            <input
              class="form-control"
              type="tel"
              v-model="Userdata.Telephone"
            >
            <!-- 郵遞區號 -->
            <label
              for="add_address"
              class="col-form-label"
            >
              <span style="color: red">
                *
              </span>
              郵遞區號:
            </label>
            <input
              class="form-control"
              type="tel"
              v-model="Userdata.PostalCode"
            >
            <!-- 地址 -->
            <label
              for="add_address"
              class="col-form-label"
            >
              <span style="color: red">
                *
              </span>
              寄送地址:
            </label>
            <input
              class="form-control"
              type="text"
              v-model="Userdata.Address"
            >
            <label
              class="col-form-label"
            >
              備註(若訂單內含彌封信封，請註明欲彌封之證件名稱及數量)
            </label>
            <textarea
              class="form-control"
              rows="3"
              maxlength="300"
              v-model="RemarkForSeal"
            />
            <hr>
            <button
              class="btn btn-secondary mr-2"
              type="button"
              data-dismiss="modal"
            >
              取消
            </button>
            <button
              class="btn btn-primary"
              type="button"
              :disabled="confirmDisable"
              @click="PostUserDatas"
            >
              確認結帳
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 結帳成功 -->
    <div
      id="checkoutOk"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="checkoutOkTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div class="modal-content content-color">
          <div class="modal-header">
            <h5
              id="checkoutOkTitle"
              class="modal-title"
            >
              <font-awesome-icon
                icon="check-circle"
                style="color: #0069ff;"
                size="1x"
              />
              成功
            </h5>
          </div>
          <div class="modal-body content-color">
            結帳成功!請進行「繳費」步驟!<br><br>
            繳款項目編號：{{ FeeOrderId }}<br>
            按下「
            <span style="color: #2600ff; font-weight: bold;">
              確認
            </span>
            」按鍵後，將自動轉至多元繳費系統，<br>
            <span style="color: red">
              請於
              <a
                target="_blank"
                href="https://ipay.nuk.edu.tw/"
                rel="noopener noreferrer"
              >
                <span style="color: red">
                  多元繳費系統
                </span>
              </a>
            </span>
            完成本筆訂單繳費，繳費成功後<br>
            可於本系統「訂單查詢」畫面，查詢「繳費狀態」<hr>
            已結帳：訂單已確認，尚未至多元繳費系統繳費<br>
            已繳費：已於多元繳費系統完成繳費<br>
            已寄出：訂單已完成並寄出，可透過郵件號碼查詢郵寄進度<br>
          </div>
          <div class="modal-footer content-color">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="CheckOutEnd()"
            >
              確認
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiOrderQuery, apiOrderDetaildelete, apiOrderCheckout, apiAccountQuery, apiPostageQuery, apiOrderModifycnt, apiAccountModify } from '../../apis/api.config.js'
import $ from 'jquery'
export default {
  data () {
    return {
      fields: [
        { key: 'index', label: '#', thClass: 'table-th', class: 'table-mini', variant: 'info' },
        { key: 'DocName', label: '證件名稱', thClass: 'table-th', class: 'table-long' },
        { key: 'SchoolYear', label: '學年度', thClass: 'table-th' },
        { key: 'Semester', label: '學期', thClass: 'table-th' },
        { key: 'DocCnt', label: '數量', thClass: 'table-th' },
        { key: 'DocAmt', label: '單價', thClass: 'table-th' },
        { key: 'TotalAmt', label: '小計', thClass: 'table-th', variant: 'warning' },
        { key: 'PaymentName', label: '繳款人(姓名)', thClass: 'table-th', class: 'table-during' },
        { key: 'Action', label: '功能', thClass: 'table-th' }
      ],
      items: [],
      Select: [],
      Userdata: {},
      OrderType: '1',
      DocTotalAmt: '',
      PostageAmt: '',
      TotalAmt: '',
      OrderNo: '',
      DeleData: '',
      FeeOrderId: '',
      num: 0,
      Engilsh: 0,
      Sealed: 0,
      RemarkForSeal: '',
      confirmDisable: false
    }
  },
  mounted () {
    this.PostCheckoutQuery()
  },
  methods: {
    PostCheckoutQuery () { // API 007 費用明細
      /* 定義資料 */
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('A_Identity'))
      /* 登入防呆 */
      if (!NewData) {
        vm.ErrorModal('請登入。')
        vm.$bus.$emit('MenuLoginOut', 'false')
        return false
      }
      /* 郵資數量歸零 */
      vm.num = 0
      const StudentData = JSON.parse(localStorage.getItem('A_StudentData'))
      vm.$bus.$emit('Loading', true)
      NewData.OrderType = 1
      NewData.StudentId = StudentData.StudentId
      /* 呼叫API */
      apiOrderQuery(NewData).then(
        res => {
          vm.$bus.$emit('Loading', false)
          if (res.status === 200) {
            if (res.data.ErrorCode === 0) {
              const Newdata = res.data.Data[0]
              if (Newdata.DocList.length === 0) {
                vm.ErrorModal('目前無結帳項目。')
                vm.$router.push({ name: 'u_Document' })
                return false
              }
              vm.OrderNo = Newdata.OrderNo
              vm.DocTotalAmt = Newdata.DocTotalAmt
              vm.PostageAmt = Newdata.PostageAmt
              vm.TotalAmt = Newdata.TotalAmt
              vm.items = Newdata.DocList
              vm.Engilsh = Newdata.IsEnglish
              /* 彌封備註 */
              vm.Sealed = Newdata.IsSealed
              for (let i = 0; i < Newdata.DocList.length; i++) {
                vm.num = vm.num + Newdata.DocList[i].DocCnt
              }
              vm.PostPostageQuery()
            } else {
              if (res.data.Data.length === 0) {
                vm.ErrorModal('目前無結帳項目。')
                vm.$router.push({ name: 'u_Document' })
                return false
              } else {
                vm.ErrorModal(res.data.Msg)
              }
            }
          } else {
            vm.ErrorModal(res.data.Msg)
          }
        }
      )
    },
    AddOrderModifycnt (data) { // 準備 API 009-1 增加-訂單單筆數量
      // 定義資料
      const vm = this
      const AddData = JSON.parse(localStorage.getItem('A_Identity'))
      AddData.OrderNo = vm.OrderNo // 訂單編號
      AddData.DocId = data.DocId // 證件代碼
      AddData.Number = (data.DocCnt + 1).toString() // 數量轉字串
      AddData.SchoolYear = data.SchoolYear // 學年
      AddData.Semester = data.Semester // 學期
      vm.PostOrderModifycnt(AddData)
    },
    ReduceOrderModifycnt (data) { // 準備 API 009-1 減少-訂單單筆數量
      // 定義資料
      const vm = this
      var NewDocCnt = data.DocCnt - 1
      if (NewDocCnt <= 0) {
        NewDocCnt = 1
      }
      const ReduceData = JSON.parse(localStorage.getItem('A_Identity'))
      ReduceData.OrderNo = vm.OrderNo // 訂單編號
      ReduceData.DocId = data.DocId // 證件代碼
      ReduceData.Number = NewDocCnt.toString() // 數量轉字串
      ReduceData.SchoolYear = data.SchoolYear // 學年
      ReduceData.Semester = data.Semester // 學期
      vm.PostOrderModifycnt(ReduceData)
    },
    PostOrderModifycnt (data) { // API 009-1 修改訂單數量
      const vm = this
      // 呼叫API
      apiOrderModifycnt(data).then(
        response => {
          vm.$bus.$emit('Loading', false)
          if (response.status === 200) {
            if (response.data.ErrorCode === 0) {
              vm.PostCheckoutQuery()
            } else {
              vm.ErrorModal(response.data.Msg)
            }
          } else {
            vm.ErrorModal(response.data.Msg)
          }
        }
      )
    },
    ShowDeleData (data) { // 準備 API 013 資料
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('A_Identity'))
      vm.DeleData = {
        APIVer: NewData.APIVer,
        ClientIP: NewData.ClientIP,
        UserId: NewData.UserId,
        Token: NewData.Token,
        OrderNo: vm.OrderNo,
        DocId: data.DocId,
        DocName: data.DocName,
        SchoolYear: data.SchoolYear,
        Semester: data.Semester
      }
      $('#DeleCheckout').modal('show')
    },
    PostDelData () { // API 013 結算明細刪除
      // 定義資料
      const vm = this
      delete vm.DeleData.DocName
      vm.$bus.$emit('Loading', true)
      const NewData = JSON.parse(JSON.stringify(vm.DeleData))
      $('#DeleCheckout').modal('hide')
      // 呼叫API
      apiOrderDetaildelete(NewData).then(
        response => {
          vm.$bus.$emit('Loading', false)
          if (response.status === 200) {
            if (response.data.ErrorCode === 0) {
              vm.PostCheckoutQuery()
            } else {
              vm.ErrorModal(response.data.Msg)
            }
          } else {
            vm.ErrorModal(response.data.Msg)
          }
        }
      )
    },
    PostUserDatas () {
      /* 編輯結帳個資 */
      const vm = this
      vm.confirmDisable = true
      const NewData = JSON.parse(localStorage.getItem('A_Identity'))
      NewData.ModifyUserId = NewData.UserId
      NewData.EnglishName = vm.Userdata.EnglishName
      NewData.Email = vm.Userdata.Email
      NewData.Telephone = vm.Userdata.Telephone
      NewData.Address = vm.Userdata.Address
      /* 郵資代碼 */
      NewData.PostalCode = vm.Userdata.PostalCode
      apiAccountModify(NewData).then(
        res => {
          if (res.status === 200) {
            if (res.data.ErrorCode === 0) {
              vm.PostCheckout()
            } else {
              vm.ErrorModal(res.data.Msg)
            }
          } else {
            vm.ErrorModal(res.data.Msg)
          }
        }
      ).finally(() => {
        this.confirmDisable = false
      })
    },
    PostCheckout () { // API 010 費用結帳
      /* 定義資料 */
      var ErrorText = ''
      const vm = this
      const NewDatas = JSON.parse(localStorage.getItem('A_Identity'))
      NewDatas.OrderNo = vm.OrderNo /* 訂單編號 */
      const Amt = vm.PostageAmt.toString(1).split(',') /* 郵資代碼 */
      if (vm.Engilsh === 1) {
        if (vm.Userdata.EnglishName === '') {
          ErrorText = '英文姓名未填。'
        }
      }
      if (Amt[1] !== '267') {
        if (vm.Userdata.Email === '') {
          ErrorText = '聯絡信箱未填。'
        }
        if (vm.Userdata.Telephone === '') {
          ErrorText = '聯絡電話未填。'
        }
        if (vm.Userdata.PostalCode === '') {
          ErrorText = '郵遞區號未填。'
        }
        if (vm.Userdata.Address === '') {
          ErrorText = '寄送地址未填。'
        }
      }
      if (ErrorText !== '') {
        $('#CheckUser').modal('hide')
        vm.ErrorModal(ErrorText)
        return
      }
      vm.$bus.$emit('Loading', true)
      // if (vm.Sealed !== 0) {
      NewDatas.RemarkForSeal = vm.RemarkForSeal
      // } else {
      //   NewDatas.RemarkForSeal = ''
      // }
      NewDatas.PostageId = Amt[1]
      NewDatas.TotalAmt = vm.TotalAmt.toString() /* 結帳總金額 */
      $('#CheckUser').modal('hide')
      /* 呼叫API */
      apiOrderCheckout(NewDatas).then(
        res => {
          vm.$bus.$emit('Loading', false)
          if (res.status === 200) {
            if (res.data.ErrorCode === 0) {
              vm.FeeOrderId = res.data.FeeOrderId
              $('#checkoutOk').modal('show')
            } else {
              vm.ErrorModal(res.data.Msg)
            }
          } else {
            vm.ErrorModal(res.data.Msg)
          }
        }
      )
    },
    CheckUserData () { // API 001 撈個人資料
      // 定義資料
      const vm = this
      if (vm.PostageAmt === 0) {
        vm.ErrorModal('請選擇郵資。')
        return
      }
      const NewData = JSON.parse(localStorage.getItem('A_Identity'))
      NewData.SearchType = 1 // 單一帳號查詢
      NewData.SearchUserId = NewData.UserId
      // 呼叫API
      apiAccountQuery(NewData).then(
        response => {
          if (response.status === 200) {
            if (response.data.ErrorCode === 0) {
              vm.Userdata = response.data.Data[0]
              $('#CheckUser').modal('show')
            } else {
              vm.ErrorModal(response.data.Msg)
            }
          } else {
            vm.ErrorModal(response.data.Msg)
          }
        }
      )
    },
    PostPostageQuery () { // API 016 郵資查詢
      // 定義資料
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('A_Identity'))
      NewData.OrderCnt = vm.num
      // 呼叫API
      apiPostageQuery(NewData).then(
        response => {
          if (response.status === 200) {
            if (response.data.ErrorCode === 0) {
              /* 郵資數量防呆 */
              vm.Select = response.data.Data
            } else {
              vm.ErrorModal('郵資' + response.data.Msg)
              vm.Select = []
            }
          } else {
            vm.ErrorModal(response.data.Msg)
            vm.Select = []
          }
        }
      )
    },
    CheckOutEnd () { // 繳費結束
      window.open('https://ipay.nuk.edu.tw/')
      this.$router.push({ name: 'i_Document' })
    },
    ErrorModal (data) {
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>

<style lang="scss">
  .span_Amount {
    color: rgb(38, 0, 255);
  }
  .inputbutton {
    line-height: 3px;
    width: 30px;
    height: 30px;
    border: 1px solid aliceblue;
    background-color: aliceblue;
    border-radius: 5px;
    vertical-align: middle;
  }
</style>
